import Navlink from "../Navlink";
import NavBar from "./NavBar.module.css"
import { Grid, Typography, Box } from "@mui/material";
import image from "../../images/brand/774x94_banner_layered_paper.png"

const DesktopNav = () => {
    return(
        <Grid container>
            
            <Grid item xs={0} sm={0} md={2} lg={2} xl={2}/>
            <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                <Box sx={{backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}>
                    <nav className={NavBar["DesktopNavigation"]}>
                        <Typography sx={{marginLeft: 2, typography: {xs: 'body2', sm: 'h6', md: 'subtitle1', lg: 'h6', xl: 'h5'}}} className={NavBar["DesktopNavigation"]}>S E A S H O R E S</Typography>
                        <Navlink/>
                    </nav>
                </Box>
            </Grid>
            <Grid item xs={0} sm={0} md={2} lg={0} xl={0}/>
        </Grid>
    )

};

export default DesktopNav;